export default {
  OPEN_INTERNAL_MANAGEMENT_DOC_MODAL: 'OPEN_INTERNAL_MANAGEMENT_DOC_MODAL',
  CLOSE_INTERNAL_MANAGEMENT_DOC_MODAL: 'CLOSE_INTERNAL_MANAGEMENT_DOC_MODAL',
  OPEN_RESPONSIBLE_DECLARATION_DOC_MODAL: 'OPEN_RESPONSIBLE_DECLARATION_DOC_MODAL',
  CLOSE_RESPONSIBLE_DECLARATION_DOC_MODAL: 'CLOSE_RESPONSIBLE_DECLARATION_DOC_MODAL'
}
